import { Col, Row } from "reactstrap";
import AsyncSelectField from "@components/fields/react-select/async-select";
import InputField from "@components/fields/input-field";
import useFilters from "@src/views/common/hooks/use-filter";
import { useFormContext } from "react-hook-form";
import KPI from "../../reports/common/kpi";

const Filter = ({ showStagesFilter = false, kpis = [], maxKPIAllowed }) => {
    const {
        control,
        formState: { errors }
    } = useFormContext();

    const { loadAsyncOptions } = useFilters();
    
    const kpiOptions = kpis?.map((kpi) => ({
        value: kpi?.name,
        label: kpi?.name
            ?.replace(/_/g, " ")
            ?.replace(/\b\w/g, (char) => char.toUpperCase()),
        disabled: false,
        checked : kpi?.value
    })) || [];
    
    return (
        <Row>
            <Col lg={12}>
                <InputField 
                    label="Name" 
                    id="company_name" 
                    control={control} 
                    errors={errors} 
                    name="company_name"/>
            </Col>
            <Col lg={6}>
                <AsyncSelectField
                    loadOptions={(value, callback) => {
                        loadAsyncOptions({
                            value,
                            callback,
                            type       : "csm",
                            context    : {},
                            statusCheck: false
                        });
                    }}
                    defaultOptions
                    id="csm"
                    isClearable
                    label="CSM"
                    name="csm"
                    control={control}
                    errors={errors}/>
            </Col>
            <Col lg={6}>
                <AsyncSelectField
                    loadOptions={(value, callback) => {
                        loadAsyncOptions({
                            value,
                            callback,
                            type       : "sdr",
                            context    : {},
                            statusCheck: false
                        });
                    }}
                    defaultOptions
                    id="sdr"
                    isClearable
                    label="SDR"
                    name="sdr"
                    control={control}
                    errors={errors}/>
            </Col>
            <Col>
                {showStagesFilter && (
                    <AsyncSelectField
                        loadOptions={(value, callback) => {
                            loadAsyncOptions({
                                value,
                                callback,
                                type       : "stages",
                                context    : {},
                                statusCheck: false
                            });
                        }}
                        defaultOptions
                        id="stage"
                        isClearable
                        label="Stage"
                        name="stage"
                        control={control}
                        errors={errors}/>
                )}
            </Col>

            {/* <Col lg={12}>
                <InputField 
                    label="Domain" 
                    id="domain" 
                    control={control} 
                    errors={errors} 
                    name="domain"/>
            </Col> */}
            <Col lg={12}>
                <InputField
                    label="Max MRR"
                    id="max_mrr"
                    type="number"
                    min={0}
                    control={control}
                    errors={errors}
                    placeholder="Enter maximum MRR"
                    name="max_mrr"/>
            </Col>
            <Col lg={12}>
                <InputField
                    label="Min MRR"
                    min={0}
                    id="min_mrr"
                    type="number"
                    control={control}
                    errors={errors}
                    placeholder="Enter minimum MRR"
                    name="min_mrr"/>
            </Col>

            {kpiOptions?.length > 0 && (
                <Col lg={12}>
                    <div>
                        <KPI
                            kpiOptions={kpiOptions ?? []}
                            maxKPIAllowed={maxKPIAllowed ?? 0}/>
                    </div>
                </Col>
            )}
        </Row>
    );
};

export default Filter;